import CompanyDTO from "@/dto/company/CompanyDTO";
import {IProfile} from "@/dto/IProfile";
import { EmploymentType } from "@/constants/EmploymentType";
import {EmploymentStatus} from "@/components/payroll/business/employments/contractors/Contractor";
import {ProjectDTO} from "@/dto/payroll/ProjectDTOs";
import TarifficationDto from "@/dto/payroll/Tariffication";
import PersonDTO from "@/dto/person/PersonDTO";

export interface IEmployment {
    id: number | null,
    employer: CompanyDTO,
    employmentStart: Date | null,
    employmentTermination: Date | null,
    details: IProfile | PersonDTO,
    employmentType: EmploymentType | null,
    status: EmploymentStatus | null,
    projects: ProjectDTO[],
    route: ProfileRoute
}

export interface TariffedEmployment extends IEmployment{
    tariffication: TarifficationDto
}

export interface ProfileRoute {
    name: string
    params: any
}

export enum ContractorType {
    INDIVIDUAL_DOMESTIC= "INDIVIDUAL_DOMESTIC",
    BUSINESS_DOMESTIC = "BUSINESS_DOMESTIC",
    INDIVIDUAL_FOREIGN = "INDIVIDUAL_FOREIGN",
    BUSINESS_FOREIGN = "BUSINESS_FOREIGN",
}

